import { Component, OnInit, Injectable } from '@angular/core';
import { USER_ROLES } from 'src/app/core/constants/cms-user-roles';
import { UserRolesService } from 'src/app/shared/services/user-roles.service';
import { AppConfig } from '../../app-config';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
})
@Injectable()
export class SidebarComponent implements OnInit {
  cmsUrl = '';
  shakespeareUrl = '';
  isAdmin = false;
  canDeleteContentList = false;
  canEditTopic = false;

  constructor(
    private appConfig: AppConfig,
    private userRolesService: UserRolesService
  ) {}

  ngOnInit() {
    this.cmsUrl = this.appConfig.cmsUrl;
    this.shakespeareUrl = this.appConfig.shakespeareUrl;

    this.userRolesService
      .isUserInRole(USER_ROLES.Admin)
      .subscribe((x) => (this.isAdmin = x));

    this.userRolesService
      .isUserInRole(USER_ROLES.CanEditTopic)
      .subscribe((x) => (this.canEditTopic = x));
  }
}
